/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions';

/**
 * @type FxIdWebFeaturesPlayGameResponseSupport
 * 
 * @export
 */
export type FxIdWebFeaturesPlayGameResponseSupport = FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions;

export function FxIdWebFeaturesPlayGameResponseSupportFromJSON(json: any): FxIdWebFeaturesPlayGameResponseSupport {
    return FxIdWebFeaturesPlayGameResponseSupportFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseSupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponseSupport {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesPlayGameResponseSupportToJSON(json: any): any {
    return FxIdWebFeaturesPlayGameResponseSupportToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseSupportToJSONTyped(value?: FxIdWebFeaturesPlayGameResponseSupport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON(value as FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions);
    }

    return {};
}

